import React from "react";
import PropTypes from "prop-types";
import ConnectedDeliveryNote from "../Pages/PaymentPage/ConnectedDeliveryNote";

const DeliveryNoteControl = ({ controlId, isVisible }) =>
    isVisible && (
        <div className="-margin-top--15">
            <ConnectedDeliveryNote controlId={controlId} />
        </div>
    );

DeliveryNoteControl.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    controlId: PropTypes.number.isRequired,
};

export default DeliveryNoteControl;
